import React, {useEffect, useState} from 'react';
import {Button, Card, Form, Input, message, Modal, Select, Row, Col} from 'antd';
import {SaveOutlined} from '@ant-design/icons';
import {
    useGetNotificationsQuery
} from '../../../slices/rootApiSlices/notificaitonsApiSlice';
import {
    useDeleteNotificationMutation,
    useUpdateNotificationMutation
} from "../../../slices/rootApiSlices/settingsApiSlice";
import {useSelector} from 'react-redux';
import SearchUsers from '../../../components/SearchUsers';
import SearchVehicleWithID from "../../../components/SearchVehicleWithID";
import parameterList from './parameterList';

const NotificationUpdateModal = ({visible, onClose, data}) => {

    const [form] = Form.useForm();
    const {user} = useSelector((state) => state.auth);
    const [deleteNotification, {isLoading}] = useDeleteNotificationMutation();
    const [updateNotification, {isLoading: updateLoading}] = useUpdateNotificationMutation();
    const {refetch} = useGetNotificationsQuery(user?.token);
    const [thresholdValue, setThresholdValue] = useState(null);
    const [vehicle_id, setVehicleID] = useState("");
    const [selectedEmail, setSelectedEmail] = useState("");

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                parameter: data.parameter,
                thresholdValue: data.threshold_value,
                thresholdOperator: data.threshold_operator,
                email: data.email,
                notificationMethod: data.notification_method,
                vehicle_id: data.vehicle_id,
                plateNumber: data.plateNumber,
                isActive: data.isActive,
            });
            setThresholdValue(data.threshold_value);
            setSelectedEmail(data.email);
        }
    }, [data, form]);


    const onFinish = async () => {
        try {
            const values = form.getFieldsValue();
            const updateValue = {
                email: selectedEmail,
                isActive: values.isActive,
                notification_method: values.notificationMethod,
                parameter: values.parameter,
                threshold_operator: values.thresholdOperator,
                threshold_value: values.thresholdValue,
                vehicle_id: values.vehicle_id,
            };
            console.log("Update Values:", updateValue);
            await updateNotification({
                token: user?.token,
                data: updateValue,
                id: data?.id
            }).unwrap();
            message.success('Bildirim güncelleme işlemi başarılı', 5);
            refetch();
            onClose();
        } catch (error) {
            message.error(error?.data?.messageTR || 'Bir hata oluştu. Lütfen tekrar deneyiniz.', 5);
        }
    };

    const handleDelete = async () => {
        try {
            await deleteNotification({token: user?.token, id: data?.id}).unwrap();
            refetch();
            message.success('Bildirim başarılı bir şekilde silindi.', 3);
            onClose();
        } catch (e) {
            message.error('Bildirim silme esnasında hata oluştu.Lütfen tekrar deneyiniz.', 3);
            onClose();
        }
    };


    const {Option} = Select;

    const isThresholdWarningOrError = (parameter) => {
        return parameterList.some((item) => item.value === parameter && parameter.startsWith('TT'));
    };

    return (
        <Modal
            width={1000}
            title="Bildirim Güncelle"
            open={visible}
            onCancel={onClose}
            footer={[
                <Button
                    type="danger"
                    onClick={handleDelete}
                >
                    Sil
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    htmlType="submit"
                    loading={isLoading || updateLoading}
                    onClick={() => form.submit()}
                    icon={<SaveOutlined/>}
                >
                    Güncelle
                </Button>,
            ]}
        >
            <Card type="inner" size="small" bordered={true}>
                <Form form={form} name="update-notification" onFinish={onFinish} layout="horizontal">
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Parametre"
                                name="parameter"
                                rules={[
                                    {required: true, message: 'Lütfen parametre seçiniz!'},
                                ]}
                            >
                                <Select placeholder="Parametre" allowClear>
                                    {parameterList.map((item, index) => (
                                        <Option key={index} value={item.value}>
                                            {item.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            {isThresholdWarningOrError(form.getFieldValue('parameter')) ? (
                                <Form.Item
                                    label="Threshold Değeri"
                                    name="thresholdValue"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Lütfen arıza veya uyarı seçiniz!',
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Arıza/Uyarı Seç"
                                        onChange={(value) => setThresholdValue(value)}
                                    >
                                        <Option value={1}>Uyarı</Option>
                                        <Option value={2}>Arıza</Option>
                                    </Select>
                                </Form.Item>
                            ) : (
                                <Form.Item
                                    label="Threshold Değeri"
                                    name="thresholdValue"
                                    rules={[
                                        {required: true, message: 'Lütfen threshold değeri giriniz!'},
                                    ]}
                                >
                                    <Input
                                        placeholder="Threshold Değeri"
                                        onChange={(e) => setThresholdValue(e.target.value)}
                                    />
                                </Form.Item>
                            )}
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Threshold Operatörü"
                                name="thresholdOperator"
                                rules={[
                                    {
                                        required: thresholdValue !== 1 && thresholdValue !== 2,
                                        message: 'Lütfen operatör seçiniz!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Operatör"
                                    allowClear
                                    disabled={thresholdValue === 1 || thresholdValue === 2}
                                >
                                    <Option value=">">Büyüktür</Option>
                                    <Option value="<">Küçüktür</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Kullanıcı"
                                name="email"
                            >
                                <SearchUsers
                                    onChange={(value) => {
                                        console.log("Selected User:", value?.value);
                                        setSelectedEmail(value?.value);
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Bildirim Türü"
                                name="notificationMethod"
                                rules={[
                                    {
                                        required: thresholdValue !== 1 && thresholdValue !== 2,
                                        message: 'Lütfen operatör seçiniz!',
                                    },
                                ]}
                            >
                                <Select placeholder="Bildirim Türü" allowClear disabled={isLoading}>
                                    <Option value="push">Web Push Bildirimi</Option>
                                    <Option value="email">E-posta</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Durum"
                                name="isActive"
                                rules={[
                                    {required: true, message: 'Lütfen durum seçiniz!'},
                                ]}
                            >
                                <Select placeholder="Durum" allowClear>
                                    <Option value={true}>Aktif</Option>
                                    <Option value={false}>Pasif</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Araç"
                                name="vehicle_id"
                                value={vehicle_id}
                            >
                                <SearchVehicleWithID
                                    onChange={(id) => {
                                        setVehicleID(id);
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </Modal>
    );
};

export default NotificationUpdateModal;
